<template>
  <div class="topic">
    <div class="list" v-for="(item,index) in namelist" :key="'list_' + index">
      <van-tag color="#F3F9FF"># {{item}} #</van-tag>
      <span class="f-r c-gray" @click="delTopic(index)">删除</span>
    </div>
    <div class="btnbott">
      <van-button color="#F8F8F8" @click="delAll()">全部删除</van-button>
    </div>
  </div>
</template>
<script>
  import post from '../../../api/lexus/release';
  import common from '../../../api/common';
  import { Button,Tag,Dialog  } from 'vant';
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        idlist:[],
        namelist:[],
        img:{
          approve: require('../../../assets/img/lexus/member/approceing.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },

    
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      var ilist=JSON.parse(this.$route.query.idlist)
      var nlist=JSON.parse(this.$route.query.namelist)
      this.idlist=ilist.idlist
      this.namelist=nlist.namelist
      console.log(this.idlist)
      console.log(this.namelist)
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      var params={
        event_code: '删除话题',
        event_id:'',
        title: '',
        value: '',
        path: '/Lexus/Release/DelTopic.vue',
        user_id: this.user_id ? this.user_id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    activated () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      var ilist=JSON.parse(this.$route.query.idlist)
      var nlist=JSON.parse(this.$route.query.namelist)
      this.idlist=ilist.idlist
      this.namelist=nlist.namelist
    },
    methods: {
      delTopic(index){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            this.$appService.needLogin()
          }
        })
        Dialog.confirm({
          message: '是否删除话题？'
        }).then(() => {
          this.idlist.splice(index,1);
          this.namelist.splice(index,1);
          var params={
            idlist:this.idlist,
            namelist:this.namelist,
            type:2
          }
          this.$appService.choiseType(params)
        }).catch(() => {
        });
      },
      delAll(){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            this.$appService.needLogin()
          }
        })
        Dialog.confirm({
          message: '是否删除全部话题？'
        }).then(() => {
          this.idlist=[]
          this.namelist=[]
          var params={
            idlist:[],
            namelist:[],
            type:2
          }
          this.$appService.choiseType(params)
        }).catch(() => {
        });
      }
    },
    components: {
      [Button.name]:Button,
      [Tag.name]:Tag,
      [Dialog.name]:Dialog
    }
  }
</script>
<style lang="scss">
.topic{
  padding: 15px;
  .list{
    font-size: 12px;
    margin-top: 20px;
    .van-tag{
      color: #728FC4;
    }
  }
  .btnbott{
    position: fixed;
    bottom: 20px;
    width: 92%;
    .van-button{
      width: 100%;
      .van-button__text{
        color: #9A9A9A;
      }
    }
  }
}
</style>
